
<button 
    class="mat-flat-button" 
    [ngClass]="{'mat-elevation-z2': fs.filters.length > 0}" 
    (click)="togglePanel()">
    <mat-icon>filter_list</mat-icon> Filter
</button>
<mat-card [ngClass]="{open: panelOpen}">
    <mat-card-content>
        <div fxLayout="column" class="filters" *ngIf="fs.filters.length > 0">
            <div fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="start center" *ngFor="let filter of fs.filters; let filterIndex = index">
                <mat-icon (click)="fs.removeFilter(filterIndex)">close</mat-icon> <span class="clause">
                    {{filterIndex === 0 ? 'Where' : ''}}
                    <span *ngIf="filterIndex === 1">
                        <mat-form-field>
                            <mat-select [(ngModel)]="fs.query.relation" (selectionChange)="fs.changeValues()">
                                <mat-option [value]="'And'">And</mat-option>
                                <mat-option [value]="'Or'">Or</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </span>
                    {{filterIndex > 1 ? fs.query.relation : ''}}
                </span> <mat-form-field>
                    <mat-select [(ngModel)]="filter.field" [compareWith]="fieldComp" (selectionChange)="fs.changeFilter(filterIndex)">
                        <mat-option *ngFor="let field of fs.fields | doNotFilter: fs.doNotFilter | orderBy: 'name'" [value]="field">{{field.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field *ngIf="filter.field && filter.field.options.length > 1">
                    <mat-select [(ngModel)]="filter.matcher" [compareWith]="matcherComp" (selectionChange)="fs.changeMatcher(filterIndex)">
                        <mat-option *ngFor="let matcher of fs.matchers | matcher: filter.field.options" [value]="matcher">{{matcher.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <span class="mat-form-field-infix" *ngIf="filter.field && filter.field.options.length === 1">{{filter.field.options[0]}}</span>
                <ng-container *ngIf="filter.matcher?.template">

                    <!-- textfield -->
                    <mat-form-field *ngIf="filter.matcher.template == 'textField'">
                        <input  matInput
                            [(ngModel)]="filter.values"
                            (input)="fs.changeValues()"
                            name="filtersAnonymous"
                            autocomplete="filtersAnonymous"
                            id="filtersAnonymous{{filtersAnonymous}}">
                    </mat-form-field>

                    <!-- type -->
                    <mat-form-field *ngIf="filter.matcher.template == 'type'">
                        <mat-select [(ngModel)]="filter.values" (selectionChange)="fs.changeValues()">
                            <mat-option [value]="'slideshow'">Slideshow</mat-option>
                            <!-- <mat-option [value]="'summary'">Summary</mat-option> -->
                            <mat-option [value]="'quiz'">Quiz</mat-option>
                            <mat-option [value]="'rsoc'">RSOC</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <!-- quizType -->
                    <mat-form-field *ngIf="filter.matcher.template == 'quizType'">
                        <mat-select [(ngModel)]="filter.values" (selectionChange)="fs.changeValues()">
                            <mat-option [value]="['', 'normal']">Standard</mat-option>
                            <mat-option [value]="'personality'">Personality</mat-option>
                        </mat-select>
                    </mat-form-field>
    
                    <!-- datePicker -->
                    <mat-form-field *ngIf="filter.matcher.template == 'datePicker'">
                        <input matInput
                            [matDatepicker]="picker"
                            [(ngModel)]="filter.values"
                            (dateInput)="fs.changeValues()"
                            name="filtersDatePicker"
                            autocomplete="filtersDatePicker"
                            id="filtersDatePicker{{filtersDatePicker}}">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>

                    <!-- datePicker2 -->
                    <mat-form-field *ngIf="filter.matcher.template == 'datePicker2'">
                        <input matInput
                            [matDatepicker]="picker1"
                            (dateInput)="fs.addDateValue(filter, $event.value, 0)"
                            name="filtersDatePicker2"
                            autocomplete="filtersDatePicker2"
                            id="filtersDatePicker2{{filtersDatePicker2}}">
                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field *ngIf="filter.matcher.template == 'datePicker2'">
                        <input matInput
                            [matDatepicker]="picker2"
                            (dateInput)="fs.addDateValue(filter, $event.value, 1)"
                            name="filtersDatePicker3"
                            autocomplete="filtersDatePicker3"
                            id="filtersDatePicker3{{filtersDatePicker3}}">
                        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                    </mat-form-field>

                    <!-- users -->
                    <mat-form-field *ngIf="filter.matcher.template == 'users'">
                        <mat-select [(ngModel)]="filter.values" (selectionChange)="fs.changeValues()" multiple="true">
                            <mat-option *ngFor="let user of fs.users" [value]="user.id">{{user.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <!-- check -->
                    <mat-checkbox *ngIf="filter.matcher.template == 'check'" [(ngModel)]="filter.values" (change)="fs.changeValues()"></mat-checkbox>
                    
                    <!-- site -->
                    <mat-form-field *ngIf="filter.matcher.template == 'site'">
                        <mat-select [(ngModel)]="filter.values" (selectionChange)="fs.changeValues()">
                            <mat-option *ngFor="let site of fs.sites" [value]="site.blog_id">{{site.domain}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <!-- hasSite -->
                    <mat-form-field *ngIf="filter.matcher.template == 'hasSite'">
                        <mat-select [(ngModel)]="filter.values" (selectionChange)="fs.changeValues()" multiple="true">
                            <mat-option *ngFor="let site of fs.sites" [value]="site.blog_id">{{site.domain}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <!-- priority -->
                    <mat-form-field *ngIf="filter.matcher.template == 'priority'">
                        <mat-select [(ngModel)]="filter.values" (selectionChange)="fs.changeValues()">
                            <mat-option [value]="'0'">High</mat-option>
                            <mat-option [value]="'1'">Normal</mat-option>
                            <mat-option [value]="'2'">Low</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <!-- status -->
                    <mat-form-field *ngIf="filter.matcher.template == 'status'">
                        <mat-select [(ngModel)]="filter.values" (selectionChange)="fs.changeValues()" multiple="true">
                            <mat-option *ngFor="let status of fs.statuses" [value]="status.value">{{status.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <!-- tax -->
                    <mat-form-field *ngIf="filter.matcher.template == 'tax'">
                        <mat-select [(ngModel)]="filter.values" (selectionChange)="fs.changeValues()" multiple="true">
                            <mat-option *ngFor="let tax of api.taxonomies | keyvalue: api.taxonomies" [value]="tax.slug">{{tax.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <!-- term -->
                    <mat-form-field *ngIf="filter.matcher.template == 'term'">
                        <mat-select [(ngModel)]="filter.values" (selectionChange)="fs.changeValues()" multiple="true">
                            <mat-option *ngFor="let term of api.taxonomies[filter.field.column].options" [value]="term.slug">{{term.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <!-- affiliates -->
                    <mat-form-field *ngIf="filter.matcher.template == 'affiliates'">
                        <mat-select [(ngModel)]="filter.values" (selectionChange)="fs.changeValues()" multiple="true">
                            <mat-option *ngFor="let affiliate of api.affiliates" [value]="affiliate">{{affiliate}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                </ng-container>
            </div>
        </div>
        <div>
            <span class="add-filter" (click)="fs.addFilter()">
                <mat-icon>add</mat-icon> Add Filter
            </span>
            <span class="reset-filter" (click)="fs.resetFilters()">
                <mat-icon>close</mat-icon> Reset Filter 
            </span>
        </div>
    </mat-card-content>
</mat-card>